var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c(
        "div",
        { staticClass: "title" },
        [
          _c(
            "el-breadcrumb",
            [
              _c("el-breadcrumb-item", [_vm._v("业务管理")]),
              _c("el-breadcrumb-item", [_vm._v("工单管理")]),
              _c("el-breadcrumb-item", [_vm._v("服务器")]),
              _c("el-breadcrumb-item", [_vm._v(" IDC支持")])
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-radio-group",
            {
              staticStyle: { "margin-bottom": "20px" },
              on: { change: _vm.handleTabChange },
              model: {
                value: _vm.tabPosition,
                callback: function($$v) {
                  _vm.tabPosition = $$v
                },
                expression: "tabPosition"
              }
            },
            [
              _c("el-radio-button", { attrs: { label: "2" } }, [
                _vm._v("IDC现场监管")
              ]),
              _c("el-radio-button", { attrs: { label: "3" } }, [
                _vm._v("IDC机房巡检")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("div", { staticClass: "title-en" }, [_vm._v("搜索条件")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "search-container" },
          [
            _c(
              "el-form",
              {
                staticClass: "search-form",
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  "label-width": "100px"
                }
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "建单时间" } },
                          [
                            _c("el-date-picker", {
                              staticStyle: { width: "100%" },
                              attrs: {
                                type: "daterange",
                                "range-separator": "-",
                                "start-placeholder": "开始日期",
                                "end-placeholder": "结束日期",
                                "value-format": "yyyy-MM-dd"
                              },
                              on: { change: _vm.handleDateChange },
                              model: {
                                value: _vm.searchForm.create_time,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "create_time", $$v)
                                },
                                expression: "searchForm.create_time"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "PO单号" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入PO单号" },
                              model: {
                                value: _vm.searchForm.opTicketid,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "opTicketid", $$v)
                                },
                                expression: "searchForm.opTicketid"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "工单单号" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入工单工号" },
                              model: {
                                value: _vm.searchForm.ticket_id,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "ticket_id", $$v)
                                },
                                expression: "searchForm.ticket_id"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "处理人" } },
                          [
                            _c("el-input", {
                              attrs: { placeholder: "请输入处理人" },
                              model: {
                                value: _vm.searchForm.handle_user,
                                callback: function($$v) {
                                  _vm.$set(_vm.searchForm, "handle_user", $$v)
                                },
                                expression: "searchForm.handle_user"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "区域-园区" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { clearable: "", placeholder: "请选择" },
                                on: { focus: _vm.handleSelectFocus },
                                model: {
                                  value: _vm.searchForm.campusName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "campusName", $$v)
                                  },
                                  expression: "searchForm.campusName"
                                }
                              },
                              _vm._l(_vm.campusOptions, function(item, index) {
                                return _c("el-option", {
                                  key: index,
                                  attrs: {
                                    label: Object.values(item)[0],
                                    value: Object.values(item)[0]
                                  }
                                })
                              }),
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "工单等级" } },
                          [
                            _c(
                              "el-select",
                              {
                                attrs: { clearable: "", placeholder: "请选择" },
                                model: {
                                  value: _vm.searchForm.SlALevel,
                                  callback: function($$v) {
                                    _vm.$set(_vm.searchForm, "SlALevel", $$v)
                                  },
                                  expression: "searchForm.SlALevel"
                                }
                              },
                              [
                                _c("el-option", {
                                  attrs: { label: "重要的", value: "0" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "一级", value: "一级" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "二级", value: "二级" }
                                }),
                                _c("el-option", {
                                  attrs: { label: "三级", value: "三级" }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 20 } },
                  [
                    _c("el-col", { attrs: { span: 6 } }, [
                      _c(
                        "div",
                        { staticClass: "search-button" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: { click: _vm.handleSearch }
                            },
                            [_vm._v("点击查询")]
                          ),
                          _c("el-button", { on: { click: _vm.handleReset } }, [
                            _vm._v("重置")
                          ]),
                          _c(
                            "el-button",
                            { on: { click: _vm.debouncedExport } },
                            [_vm._v(_vm._s(_vm.exportButtonText))]
                          )
                        ],
                        1
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("div", { staticClass: "title-en" }, [_vm._v("IDC支持列表")]),
      _c("el-card", { staticClass: "box-card" }, [
        _c(
          "div",
          { staticClass: "table-container" },
          [
            _c(
              "div",
              { staticClass: "button-container" },
              [
                _c("el-button", { on: { click: _vm.handleExport } }, [
                  _vm._v("催办")
                ]),
                _c("el-button", { on: { click: _vm.handleExport } }, [
                  _vm._v("审计派单")
                ]),
                _c("el-button", { on: { click: _vm.openColumnsDialog } }, [
                  _vm._v("表头设置")
                ])
              ],
              1
            ),
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                ref: "table",
                attrs: { data: _vm.faults, border: "", stripe: "" },
                on: { "selection-change": _vm.handleSelectionChange }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "selection", width: "55", align: "center" }
                }),
                _vm._l(_vm.visibleColumns, function(column, index) {
                  return _c("el-table-column", {
                    key: index,
                    attrs: {
                      prop: column.prop,
                      label: column.label,
                      width: column.width,
                      align: column.align,
                      fixed: column.fixed
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              column.prop === "operation"
                                ? _c(
                                    "span",
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "text",
                                            size: "small"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleViewDetail(
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v("查看详情")]
                                      )
                                    ],
                                    1
                                  )
                                : column.prop === "campusName"
                                ? _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        scope.row.campusName ===
                                          "张家口-怀来东园"
                                          ? "怀来-东园"
                                          : scope.row[column.prop] || "-"
                                      )
                                    )
                                  ])
                                : column.prop === "opTicketid"
                                ? _c("span", [
                                    scope.row.opTicketid
                                      ? _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "https://dcops.fre.tencent-cloud.com/operateManage/business/ToDoDetails?params=" +
                                                scope.row.opTicketid +
                                                "&isHistory=1",
                                              target: "_blank"
                                            }
                                          },
                                          [_vm._v(_vm._s(scope.row.opTicketid))]
                                        )
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(scope.row.opTicketid || "-")
                                          )
                                        ])
                                  ])
                                : ["amount", "realNum"].includes(column.prop)
                                ? _c("span", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          scope.row[column.prop] === 0 ||
                                            scope.row[column.prop]
                                            ? scope.row[column.prop]
                                            : "-"
                                        ) +
                                        "\n            "
                                    )
                                  ])
                                : column.prop === "feedback_status"
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          scope.row.feedback_status === "已完成"
                                            ? "success"
                                            : scope.row.feedback_status ===
                                              "处理中"
                                            ? "warning"
                                            : scope.row.feedback_status ===
                                              "待处理"
                                            ? "info"
                                            : "danger",
                                        size: "small"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(
                                            scope.row.feedback_status || "-"
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : column.prop === "time_out"
                                ? _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type:
                                          scope.row.time_out === "已超时"
                                            ? "danger"
                                            : "success",
                                        size: "small"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(scope.row.time_out || "-") +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(scope.row[column.prop] || "-")
                                    )
                                  ])
                            ]
                          }
                        }
                      ],
                      null,
                      true
                    )
                  })
                })
              ],
              2
            ),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "设置显示项",
                  visible: _vm.showColumnsDialog,
                  "append-to-body": true,
                  width: "400px",
                  "close-on-click-modal": false,
                  "custom-class": "columns-dialog",
                  "modal-append-to-body": false,
                  "destroy-on-close": true
                },
                on: {
                  "update:visible": function($event) {
                    _vm.showColumnsDialog = $event
                  }
                }
              },
              [
                _c(
                  "el-checkbox-group",
                  {
                    staticClass: "checkbox-group",
                    model: {
                      value: _vm.selectedColumns,
                      callback: function($$v) {
                        _vm.selectedColumns = $$v
                      },
                      expression: "selectedColumns"
                    }
                  },
                  _vm._l(_vm.columns, function(column) {
                    return _c(
                      "el-checkbox",
                      {
                        key: column.prop,
                        staticClass: "checkbox-item",
                        attrs: { label: column.prop }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(column.label) +
                            "\n          "
                        )
                      ]
                    )
                  }),
                  1
                ),
                _c(
                  "div",
                  {
                    staticClass: "dialog-footer",
                    attrs: { slot: "footer" },
                    slot: "footer"
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.selectAllColumns }
                      },
                      [_vm._v("全选")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small" },
                        on: { click: _vm.restoreDefaultColumns }
                      },
                      [_vm._v("恢复默认")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "small", type: "primary" },
                        on: { click: _vm.saveColumnsDialog }
                      },
                      [_vm._v("保存")]
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-container" },
              [
                _c("el-pagination", {
                  attrs: {
                    "current-page": _vm.currentPage,
                    "page-sizes": [10, 20, 30, 50],
                    "page-size": _vm.pageSize,
                    layout: "total, sizes, prev, pager, next, jumper",
                    total: _vm.total
                  },
                  on: {
                    "size-change": _vm.handleSizeChange,
                    "current-change": _vm.handleCurrentChange
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }